import { createElement } from 'rax';
import View from '../view';
import Icon from '../icon';
import { FieldElement } from '../field';
import Switch from '../switch';
import './index.scss';
export default class SwitchField extends FieldElement {
    getValueName() {
        return 'checked';
    }
    renderPreview(value) {
        const { prefix = 'mt-' } = this.props;
        return (<View className={`${prefix}switch-field-preview`}>
        <Icon name={value ? 'select' : 'close'}/>
      </View>);
    }
    renderControl() {
        return <Switch {...this.getProps()}/>;
    }
}
SwitchField.displayName = 'SwitchField';
